export default __webpack_public_path__ + "static/media/connect.2705ef2a.svg";